"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VKITAuthUrl = exports.VKITAuthStorage = exports.VKITAuthProvider = exports.VKITAuthParams = void 0;
/**
 * @description Enumeration of response query params
 */
var VKITAuthParams;
(function (VKITAuthParams) {
    VKITAuthParams["CODE"] = "auth_code";
    VKITAuthParams["ERROR"] = "auth_error";
    VKITAuthParams["PROVIDER"] = "auth_provider";
    VKITAuthParams["STATE"] = "auth_state";
})(VKITAuthParams = exports.VKITAuthParams || (exports.VKITAuthParams = {}));
/**
 * @description Auth provider enumeration
 */
var VKITAuthProvider;
(function (VKITAuthProvider) {
    VKITAuthProvider["ADFS"] = "adfs";
    VKITAuthProvider["MOBILE_ID"] = "";
})(VKITAuthProvider = exports.VKITAuthProvider || (exports.VKITAuthProvider = {}));
/**
 * @description Inner storage keys
 */
var VKITAuthStorage;
(function (VKITAuthStorage) {
    VKITAuthStorage["PROVIDER"] = "vkit/auth-provider";
    VKITAuthStorage["TOKENS"] = "vkit/auth-tokens";
})(VKITAuthStorage = exports.VKITAuthStorage || (exports.VKITAuthStorage = {}));
/**
 * @description Authorisation back-ends
 */
var VKITAuthUrl;
(function (VKITAuthUrl) {
    VKITAuthUrl["DEV"] = "https://auth-lke.kube.vimpelcom.ru";
    VKITAuthUrl["PROD"] = "https://eauth.beeline.ru";
    VKITAuthUrl["TEST"] = "https://auth-test-lke.kube.vimpelcom.ru";
})(VKITAuthUrl = exports.VKITAuthUrl || (exports.VKITAuthUrl = {}));
//# sourceMappingURL=types.js.map